var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import Label from '../Label';
import formTheme from '../theme';
import { ComponentThemeProvider } from '../../ThemeProvider';
var CheckboxGroupLabel = styled(Label)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.form.checkboxGroup.label;
});
export var CheckboxGroup = function (_a) {
    var label = _a.label, children = _a.children;
    return (React.createElement("div", null,
        React.createElement(ComponentThemeProvider, { theme: formTheme },
            React.createElement(CheckboxGroupLabel, null, label),
            children)));
};
export default CheckboxGroup;
var templateObject_1;
//# sourceMappingURL=index.js.map